// extracted by mini-css-extract-plugin
module.exports = {"card":"_1zQ8sQR_9gzFi6FpJZ_THn"};